import { useTranslation } from 'react-i18next';

/** Shown while the session is being restored. Deliberately plain. */
export function SplashScreen() {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-dvh items-center justify-center bg-surface p-6 text-ink-muted"
    >
      {t('app.loading')}
    </div>
  );
}
